const menu = {
    label: 'Clientes',
    icon: 'pi pi-fw pi-users',
    to: '/minerador/clientes',
    rules: ['MINERADOR-CLIENTES-00'],
};

export default menu;
